import { Icon } from "antd";
import React from "react";
import style from "./index.module.scss";
export default function ScoreCardFooter() {
    return (
        <p className={style.footer}>
            <Icon type="info-circle" className={style.footerIcon} />
            &nbsp;
            <span>
                说明：成绩单发布后再参与的教学互动数据会被计入学习报告统计中，但不被计入成绩中。请严格按照任课教师规定的时间完成互动，以免对成绩造成影响。
            </span>
        </p>
    );
}
